import { Row, Space, Typography } from "antd";
import React, { useMemo } from "react";
import styled from "styled-components";
import useMediaQuery from "../hooks/useMediaQuery";

interface HeaderSectionProps {
	noButtonOverride?: boolean;
	level?: 1 | 2 | 3 | 4 | 5;
	title: string;
	subtitle?: string;
	rightComponent?: React.ReactNode;
	children?: React.ReactNode;
	tabsComponent?: React.ReactNode;
	hideInfoResponsive?: boolean;
}
const HeaderSection: React.FC<HeaderSectionProps> = ({
	noButtonOverride,
	level,
	title,
	subtitle,
	rightComponent,
	children,
	tabsComponent,
	hideInfoResponsive,
}) => {
	const isBelowLg = useMediaQuery("(max-width: 991px)");
	const fullCondition = useMemo(() => {
		if (rightComponent && children && title && tabsComponent) {
			return true;
		}

		return false;
	}, [children, rightComponent, tabsComponent, title]);

	return (
		<Space direction="vertical">
			<HeaderContainer className={fullCondition ? "full-condition" : rightComponent ? "" : "no-right-comp"}>
				<Title>
					{title && (
						<Row
							style={{
								gap: 8,
								alignItems: "center",
							}}
						>
							<Typography.Title
								ellipsis={true}
								level={level || 3}
								style={
									subtitle
										? {
												margin: 0,
										  }
										: {}
								}
							>
								{title}
							</Typography.Title>
							{subtitle && (
								<Typography.Text
									type="secondary"
									style={{
										margin: 0,
									}}
								>
									{subtitle}
								</Typography.Text>
							)}
						</Row>
					)}
				</Title>
				{tabsComponent ? <Tabs>{tabsComponent}</Tabs> : <></>}
				<Content>{children}</Content>
				<RightItem className={noButtonOverride ? "no-override" : ""}>{rightComponent}</RightItem>
			</HeaderContainer>
			{!hideInfoResponsive && isBelowLg && (
				<Typography.Text style={{ color: "#8C8C8C" }}>
					Note: Best viewed on mobile in landscape mode
				</Typography.Text>
			)}
		</Space>
	);
};
const HeaderContainer = styled.div`
	display: grid;
	width: 100%;
	row-gap: 5px;
	gap: 8px;
	grid-template-columns: repeat(6, 1fr);
	grid-template-areas:
		"title title title title title title"
		"rightitem rightitem rightitem rightitem rightitem rightitem"
		"content content content content content content";
	&.no-right-comp {
		grid-template-areas:
			"title title title title title title"
			"tabs tabs tabs tabs tabs tabs"
			"content content content content content content";
	}
	&.full-condition {
		grid-template-areas:
			"title title title title title title"
			"tabs tabs tabs tabs tabs tabs"
			"content content content content content content"
			"rightitem rightitem rightitem rightitem rightitem rightitem";
	}
	@media screen and (min-width: 992px) {
		&:not(.no-right-comp) {
			grid-template-areas:
				"title title title title title title"
				"tabs tabs tabs tabs tabs tabs"
				"content content content content content rightitem";
		}
	}
`;
const Title = styled(Typography.Text)`
	grid-area: title;
	overflow: hidden;
	width: 100% !important;
`;
const Content = styled.div`
	grid-area: content;
`;
const RightItem = styled.div`
	grid-area: rightitem;
	text-align: right;
	@media screen and (max-width: 991px) {
		/* &:not(.no-override) .ant-btn span:not(.anticon) {
			display: none;
		}
		&:not(.no-override) .ant-btn span {
			display: inline-flex;
			align-items: center;
			gap: 5px;
			&::after {
				content: "Create";
			}
		}
		 */

		display: flex;
		justify-content: start;
	}
`;
const Tabs = styled.div`
	grid-area: tabs;
`;
export default HeaderSection;
